import React, { forwardRef } from 'react';

interface ImageActionButtonProps {
  icon: React.ReactNode;
  onClick: (e: React.MouseEvent) => void;
  isActive?: boolean;
  className?: string;
  title?: string;
}

const ImageActionButton = forwardRef<HTMLButtonElement, ImageActionButtonProps>(({
  icon,
  onClick,
  isActive = false,
  className = '',
  title
}, ref) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      title={title}
      className={`
        absolute w-8 h-8 rounded-[8px] 
        bg-[#D6E4FF] backdrop-blur-sm border border-none
        flex items-center justify-center
        hover:bg-[#C0D6FF] hover:shadow-md
        transition-all duration-200 ease-in-out
        z-10
        ${isActive ? 'bg-[#C0D6FF]' : ''}
        ${className}
      `}
    >
      {icon}
    </button>
  );
});

export default ImageActionButton;
